<div class="db-tenWebX">

  <div class="containers-wrap" *ngIf="builderPlugin && elementorPlugin && builderPlugin.active && elementorPlugin.active">
    <form [formGroup]="tenWebX">
      <div class="db-tenwebx__panel-row">
        <div>
          <div>Random forest:</div>
          <div><span>No</span><db-fc-switch  [formControl]="layoutMap" color="success" [inverted]="true"></db-fc-switch><span>Yes</span></div>
        </div>
      </div>
      <div>
        <div>
          <div class="db-tenwebx-field-title">Url</div>
          <textarea formControlName="websiteUrl" id="tenWebxWebsiteUrl" class="db-fc-input" [style.border-color]="(tenWebX.controls['websiteUrl'].invalid && ((tenWebX.controls['websiteUrl'].touched && !tenWebX.controls['websiteUrl'].errors['required']) || formSubmitted)) ? '#E95E5B' : null"></textarea>
          <div class="db-account-invalide-note" *ngIf="(tenWebX.controls['websiteUrl'].invalid && ((tenWebX.controls['websiteUrl'].touched && !tenWebX.controls['websiteUrl'].errors['required']) || formSubmitted))">This field is required and must contain dot. Please enter your valid domain name.</div>
          <br>
          <div class="db-tenwebx-field-title">Magic input</div>
          <input type="text" id="tenWebxMagicInput" formControlName="magicInput" [style.border-color]="(tenWebX.controls['magicInput'].invalid && ((tenWebX.controls['magicUrl'].touched && !tenWebX.controls['magicInput'].errors['required']) || formSubmitted)) ? '#E95E5B' : null"/>
        </div>
        <a class="db-button_info db-button" (click)="runTenWebX()">run</a>
      </div>
    </form>
  </div>
  <div class="db-tenwebx-empty empty-page" *ngIf="builderPlugin && elementorPlugin && (!builderPlugin.active || !elementorPlugin.active)">
    <div class="db-no-items-message">
      <div class="db-no-item-image-wrap db-tenwebx-image">
        <img class="db-no-item-image" src="assets/images/icons/builder_white_bg.svg" alt=""/>
      </div>
      <div class="db-no-item-title"><span>{{'text_emptyPageTitle' | dbText}}</span></div>
      <div class="db-no-item-desc"><span [innerHtml]="'text_builderDesc' | dbText">{{'text_builderDesc' | dbText}}</span></div>
      <div *ngIf="website?.canActivateServices"  class="db-no-item-button">
        <a class="db-button db-button_info db-button_lg" (click)="installAndActivate()"><span>{{'text_enableNow' | dbText}}</span></a>
      </div>
    </div>
  </div>

  <!--<db-loading-screen [ngClass]="{'hidden':(!(ongoingActivity$ | async) && !loading)}" [pageBlocker]="true" [loadingMessage]="(ongoingActivity$ | async)?.message || 'Website template is importing.'"></db-loading-screen>-->
</div>
